import React, { useState, useMemo } from "react";
import ReactResizeDetector from "react-resize-detector";
import { useHistory } from "react-router";
import _ from "lodash";
import { mutate } from "swr";
import { makeRequest } from "../../utils/request";
import constants from "../../config/constants";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj } from '../../analytics/analyticsObject';
const RecentPosts = ({ playlists, recentItemsTopics, recentItemsLogs, userInfo }) => {
  const history = useHistory();
  const [show, setShow] = useState(true);
  const [domHeight, setDomHeight] = useState(0);
  const [recentItems, setRecentItems] = useState(recentItemsTopics);
  const [recentLogs, setRecentLogs] = useState(recentItemsLogs);
  const bookMarkedPosts = useMemo(() => {
    let allContentKeys = [];
    if (playlists) {
      playlists.forEach(
        pl => (allContentKeys = allContentKeys.concat(pl.contentKeys))
      );
    }
    allContentKeys = [...new Set(allContentKeys)];
    return allContentKeys;
  }, [playlists]);

  const navigateToPost = (contentKey, id) => {
    history.push(`/posts/${contentKey}/${id}`);
  };

  const markRecentPostHidden = async (item, userInfo, itemsLogs) => {
    const { contentKey } = _.assign(item, { props: { hidden: 'true' } });
    const log = _.find(itemsLogs, { contentKey: contentKey });
    await makeRequest("post", "/api/log", {
      ...log,
      props: { hidden: "true" }
    });
    const updatedRecentItems = recentItems.map(l => {
      if (l.contentKey === contentKey)
        return { ...l, props: { hidden: "true" } };
      return l;
    });
    setRecentItems(recentItems);
    await mutate(
      ["/api/log/recentcontent", constants.logTypes.viewItem],
      [...updatedRecentItems]
    );
  };

  const adobeCustomLog = (item) => {
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let url = '/posts/' + item.contentKey + '/' + item.id
    let customLObj = getAdobeAnalyticsCustomLinkObj(item.title, "standardplus_recentlyvieweditems", url);
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      // pageData: false,
      adobePushTracking: false,
    });

  }
  const onResize = (width, height) => {
    setDomHeight(height);
  };
  return (
    <div
      className={`bg-white rounded border border-gray-400 w-full lg:w-1/2 my-4 md:my-10 mr-3 px-8 py-6 ${!show ? "collapsed" : ""
        }`} adoberegion="standardplus_recentlyvieweditems"
    >
      <div
        className="flex justify-between cursor-pointer"
        onClick={() => setShow(!show)}
      >
        <h3 className="text-lg text-center text-gray-800 font-normal pb-4 title-font">
          Recently viewed items
        </h3>

        <div>
          <i
            className="fas fa-chevron-down"
            style={{
              transform: !show ? "rotate(-90deg)" : "",
              transition: "all .3s ease"
            }}
          />
        </div>
      </div>

      <div
        style={{
          maxHeight: show ? domHeight + "px" : "0",
          transition: "all .2s ease-out"
        }}
        className="overflow-hidden"
      >
        <div>
          {recentItems?.length > 0 ? (
            <div className="flex flex-wrap">
              {recentItems.map(item => (
                <div
                  className="w-full sm:w-1/2 mt-2 p-2 text-center"
                  key={item.contentKey}
                >
                  <div className="bg-white border border-blue p-2 cursor-pointer flex justify-between h-full">
                    {bookMarkedPosts.includes(item.contentKey) && (
                      <span className="mr-3">
                        <i
                          className={`far fa-bookmark ${bookMarkedPosts.includes(item.contentKey)
                            ? "text-orange-600"
                            : ""
                            }`}
                          onClick={() => { adobeCustomLog(item) }}
                        />
                      </span>
                    )}
                    <span
                      onClick={() => { navigateToPost(item.contentKey, item.id); adobeCustomLog(item) }}
                    >
                      {item.title}
                    </span>
                    <span
                      className="mx-2"
                      onClick={() => markRecentPostHidden(item, userInfo, recentLogs)}
                    >
                      <i className="fas fa-times" />
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div>
              <p className="text-center italic text-gray-600 p-10 title-font">
                There is no items viewed yet.
              </p>
            </div>
          )}
          <ReactResizeDetector handleWidth handleHeight onResize={onResize} />
        </div>
      </div>
    </div>
  );
};

export default RecentPosts;
